import { setUserData, setUserLoading, updateUserField } from 'reducers/user/slice';
import { getInvestmentAccountRequest } from 'services/secondary';
import { getUserRequest } from 'services/user';
import {
  identify,
  persistAttributionUserStatus,
  deriveUserStatusFromInvestmentAccountStatus,
} from 'utils/analytics';

export const getUser =
  ({ getInvestmentAccount = false, skipRedirect: _skipRedirect = false }) =>
  async (dispatch) => {
    dispatch(setUserLoading(true));
    try {
      const userResponse = await getUserRequest();
      const user = userResponse;

      dispatch(
        setUserData({
          value: user,
        }),
      );
      dispatch(
        updateUserField({
          key: 'signedIn',
          value: true,
        }),
      );
      dispatch(setUserLoading(false));

      if (user && user.primaryUserId) {
        identify(user);
      }

      if (getInvestmentAccount) {
        const userAccountResponse = await getInvestmentAccountRequest({
          primaryUserId: user.primaryUserId,
        }).catch(() => []);

        const userAccounts = Array.isArray(userAccountResponse) ? userAccountResponse : [];
        const investmentAccountStatus = {
          hasInvestmentAccount: false,
          investmentAccountPending: false,
          investmentAccountActionRequired: false,
        };

        await userAccounts.reduce(async (item, account) => {
          await item;

          if (['OPEN', 'APPROVED'].indexOf(account.accountStatus) > -1) {
            investmentAccountStatus.hasInvestmentAccount = true;
            investmentAccountStatus.investmentAccount = account;
          }

          if (['PENDING', 'CUSTODY_TRANSFER'].indexOf(account.accountStatus) > -1) {
            investmentAccountStatus.investmentAccountPending = true;
          }

          if (account.custodianAccountStatus === 'ACTION_REQUIRED') {
            investmentAccountStatus.investmentAccountActionRequired = true;
          }

          if (['CLOSED'].indexOf(account.accountStatus) > -1) {
            investmentAccountStatus.investmentAccountClosed = true;
          }

          if (['FROZEN'].indexOf(account.accountStatus) > -1) {
            investmentAccountStatus.investmentAccountFrozen = true;
          }
        }, Promise.resolve());

        dispatch(
          updateUserField({
            key: 'investmentAccountStatus',
            value: investmentAccountStatus,
          }),
        );
        dispatch(
          updateUserField({
            key: 'userAccounts',
            value: userAccounts,
          }),
        );
        persistAttributionUserStatus(
          deriveUserStatusFromInvestmentAccountStatus(investmentAccountStatus),
        );
        // Only fire once per session per user, and strip PII from the payload
        if (typeof window !== 'undefined') {
          if (!window._investmentAccountStatusFired?.[user?.primaryUserId]) {
            window._investmentAccountStatusFired = window._investmentAccountStatusFired || {};
            window._investmentAccountStatusFired[user.primaryUserId] = true;
            window?.dataLayer?.push({
              event: 'user-investment-account-status',
              user: {
                investmentAccountStatus: {
                  hasInvestmentAccount: investmentAccountStatus.hasInvestmentAccount,
                  investmentAccountPending: investmentAccountStatus.investmentAccountPending,
                  investmentAccountActionRequired:
                    investmentAccountStatus.investmentAccountActionRequired,
                  investmentAccountClosed: investmentAccountStatus.investmentAccountClosed,
                  investmentAccountFrozen: investmentAccountStatus.investmentAccountFrozen,
                },
              },
            });
          }
        }
      }
    } catch {
      dispatch(
        updateUserField({
          key: 'hasInvestmentAccount',
          value: false,
        }),
      );
      dispatch(setUserLoading(false));
      dispatch(
        updateUserField({
          key: 'signedIn',
          value: false,
        }),
      );
    }
  };
